import { render, staticRenderFns } from "./SportModal.vue?vue&type=template&id=2f96fa88&scoped=true&"
import script from "./SportModal.vue?vue&type=script&lang=js&"
export * from "./SportModal.vue?vue&type=script&lang=js&"
import style0 from "./SportModal.vue?vue&type=style&index=0&id=2f96fa88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96fa88",
  null
  
)

component.options.__file = "SportModal.vue"
export default component.exports